import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Колекції',
    href: '#collections'
  }, {
    name: 'Каталог',
    href: '#catalog'
  }, {
    name: 'Про нас',
    href: '#about'
  }, {
    name: 'Відгуки',
    href: '#reviews'
  }, {
    name: 'Контакти',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-40 transition-all duration-300 ${isScrolled ? 'bg-brand-cream/90 backdrop-blur-md shadow-sm py-4' : 'bg-transparent py-6'}`} data-id="element-217">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between" data-id="element-218">
        {/* Logo */}
        <a href="#" aria-label="na.lilu — головна" className="flex items-center -my-8" data-id="element-219">
          <img src="https://cdn.magicpatterns.com/uploads/dtsy7m79ghQ5x7313MJovk/IMG_3734.png" alt="Логотип na.lilu" className={`w-auto object-contain transition-all duration-300 ${isScrolled ? 'h-28' : 'h-36'}`} data-id="element-220" />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-221">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-brand-dark/80 hover:text-brand-burgundy transition-colors" data-id="element-222">
              {link.name}
            </a>)}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden md:flex items-center" data-id="element-223">
          <a href="tel:+380964797313" className="flex items-center gap-2 bg-brand-burgundy text-white px-6 py-2.5 rounded-full text-sm font-medium hover:bg-brand-burgundy/90 transition-colors" data-id="element-224">
            <Phone className="w-4 h-4" data-id="element-225" />
            Зв'язатися
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2 text-brand-dark" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-226">
          {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-227" /> : <Menu className="w-6 h-6" data-id="element-228" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-229">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-brand-cream border-t border-brand-beige overflow-hidden" data-id="element-230">
            <div className="px-4 py-6 space-y-4 flex flex-col" data-id="element-231">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-lg font-medium text-brand-dark block py-2" data-id="element-232">
                  {link.name}
                </a>)}
              <a href="tel:+380964797313" className="flex items-center justify-center gap-2 bg-brand-burgundy text-white px-6 py-3 rounded-full text-base font-medium mt-4" data-id="element-233">
                <Phone className="w-5 h-5" data-id="element-234" />
                Зв'язатися
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}